<template>
  <div class="page" id="page-aboutus">
    <div class="section-header">
      <div class="container">
        <h1>제휴보험사</h1>
      </div>
    </div>

    <div class="section-body" id="alliance_frame" style="padding-bottom:40px;">
      <div class="container">          
        <div v-for="(alliance, group) in allianceList" :key="group">
          <h1 style="font-weight:700; font-size:1.5em; margin-top:10%;text-align: center;">{{ group }}</h1>
          <ul style="margin-top:20px;padding: 0 0.5rem;">
            <li v-for="(item, index) in alliance" :key="index" style="width:90px;margin-bottom:10px;">
              <a :href="item.link" target="_blank">
                <img :src="item.value" />
              </a>
              <span v-if="item.name =='메리츠화재' || item.name =='라이나생명' " >{{item.name}}</span>
              <span v-if="!(item.name =='메리츠화재') && !(item.name =='라이나생명')" >{{item.name}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      allianceList: {
        ['손해보험사']: [
          { name: '삼성화재', value: '/static/alliance/company_ss.png', link: 'https://www.samsungfire.com'},
          { name: '현대해상', value: '/static/alliance/company_hd.png', link: 'https://www.hi.co.kr'},
          { name: 'DB손해', value: '/static/alliance/company_db.png', link: 'https://www.idbins.com'},
          { name: 'KB손해', value: '/static/alliance/company_kb.png', link: 'https://www.kbinsure.co.kr'},
          { name: '메리츠화재', value: '/static/alliance/company_mz.png', link: 'https://www.meritzfire.com'},
          { name: '한화손해', value: '/static/alliance/company_hw.png', link: 'https://www.hwgeneralins.com'},
          { name: '롯데손해', value: '/static/alliance/company_lt.png', link: 'http://www.lotteins.co.kr'},
          { name: '흥국화재', value: '/static/alliance/company_hk.png', link: 'https://www.heungkukfire.co.kr'},
          { name: 'MG손해', value: '/static/alliance/company_mg.png', link: 'https://www.mggeneralins.com'},
        ],
        ['생명보험사']: [ 
          { name: '라이나생명', value: '/static/alliance/company_ln.png', link: 'https://www.lina.co.kr'},
          { name: 'DB생명', value: '/static/alliance/company_db_life.png', link: 'https://www.idblife.com'},
          { name: '흥국생명', value: '/static/alliance/company_hk.png', link: 'https://www.heungkuklife.co.kr'},
        ]
      }
    }
  },
}
</script>
<style lang="scss" scoped>
  #alliance_frame {
    max-width: 480px;
    margin: auto;
    ul {
      text-align: center;
      li {
        display: inline-block;
        text-align: center;
        margin-left: 0.5rem;
        margin-right: 0.5rem;
        & > a {
          display: inline-block;
          background: white;
          border: unset;
          border-radius: 4px;
          height: 9rem;
          line-height: 9rem;
          padding: 0 0.25rem;
          & > img {
            display: inline-block;
            vertical-align: middle;
          }
        }
        & > span {

        }
      }
    }
  }
  
  
</style>